export class NavigationHelper {

  static getQueryParam(paramName: string) {
    const urlParams = new URLSearchParams(window.location.search);
    const myParam: string = urlParams.get(paramName);
    return myParam;
  }

  static getRefreshKey() {
    return new Date().getTime().toString();
  }

  static showMobileSidebar() {
    const sb = document.getElementById("sidebar");
    const isVisible = !sb.classList.contains("d-none");
    if (!isVisible) sb.classList.remove("d-none");
  }

  static hideMobileSidebar() {
    const sb = document.getElementById("sidebar");
    const isVisible = !sb.classList.contains("d-none");
    if (isVisible) sb.classList.add("d-none");
  }

  static toggleMobileSidebar() {
    const sb = document.getElementById("sidebar");
    const isVisible = !sb.classList.contains("d-none");
    if (!isVisible) sb.classList.remove("d-none"); else sb.classList.add("d-none");
  }


}

